<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="" class="pt-4">
          <template slot="actions">

          </template>
          <div slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search" v-model="filters['search']"
              class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff" @sort="handleSort" :sst="true"
              stripe class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="thead">
                <vs-th sort-key="name">CUOTE CODE</vs-th>
                <vs-th sort-key="email">CREATED AT</vs-th>
                <vs-th>STATUS</vs-th>
                <vs-th>ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].credit_note_code">
                    {{ data[indextr].credit_note_code }}
                  </vs-td>

                  <vs-td :data="data[indextr].created_at">
                    {{ (data[indextr].created_at) }}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].status }}
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="PDF" position="left">
                        <vs-button @click="onClickUserEdit(data[indextr].credit_note_secret_code)" color="primary" type="border"
                          size="small" icon-pack="feather" icon="icon-printer"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5"></vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
const CustomerRepository = RepositoryFactory.get('customer')

export default {
  name: 'CreditNoteList',
  data() {
    return {
      selected: [],
      updateStaffSelected: [],
      options: ['Department 01', 'Department 02', 'Department 03', 'Department 04', 'Department 05', 'Department 06'],
      popupActive: false,
      createUserPopupActive: false,
      popUpTitle: '',
      editActive: false,
      edit: null,
      editProp: {},
      checkBox1: false,
      activeConfirm: false,
      staff: [],
      selectedStaff: {},
      createStaffForm: {},
      departments: [],
      users: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
    }
  },
  components: {
    'v-select': vSelect,
  },
  mixins: [Filter],
  async mounted() {
    this.$vs.loading()
    this.loadStaff()
    this.$vs.loading.close()

  },
  methods: {
    async onClickUserEdit(credit_note_secret_code) {
      this.$router.push(`/files/credit_note/${credit_note_secret_code}`)
    },
    async loadStaff() {
      this.$vs.loading()
      try {
        const { data } = await CustomerRepository.getCreditNoteList(this.page, this.filterQuery, 10, this.sort)
        this.staff = data.data
        this.meta = data.meta
        console.log(this.staff);
      } catch (error) {
        console.log(error);
      }
      this.$vs.loading.close()
    },
    filterQueryUpdate() {
      this.loadStaff()
    },

    handleChangePage(page) {
      this.page = page;
      this.loadStaff()
    },

    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.loadStaff()
      }

    }

  },
  watch: {
    page() {
      this.loadStaff()
    }
  }
}
</script>


<style scoped>
.user-edit-popup>>>.vs-popup {
  min-height: 50% !important;
  min-width: 50% !important;
}

@media (min-width: 768px) and (max-width: 1319px) {
  .user-edit-popup>>>.vs-popup {
    min-height: 50% !important;
    min-width: 65% !important;
  }
}
</style>
